import {getClient} from "utils/client";
import {nameToNumeric} from "utils/met";
import mainAllApi from "utils/apiList/api";
import { transact } from "../transact";

class Server {

    getRealIdInitialize = async (data: any)=>{
        const response = await mainAllApi.getRealIdInitialize(data)
        return response
    }

    getCompareInitialize = async (data: any)=>{
        const response = await mainAllApi.getCompareInitializeApi(data)
        return response
    }

    getCompareRecover = async (data: any)=>{
        const response = await mainAllApi.getCompareRecoverApi(data)
        return response
    }
    getCompareCheckData = async (data: any)=>{
        const response = await mainAllApi.getCompareCheck(data)
        return response
    }
    getCheckData = async (data: any)=>{
        const response = await mainAllApi.getCheck(data)
        return response
    }
    getRecoverRecords = async (data: any)=>{
      const response = await mainAllApi.getRecoverRecords(data)
      return response
    }
    getOrderErrorMsgData = async (data: any)=>{
        const response = await mainAllApi.getOrderErrorMsg(data)
        return response
    }
    getTableRowsByVendorinfo = async ()=>{
        const data = await mainAllApi.getTableRows({
            code: process.env.REACT_APP_CONTARCT_NAME,
            scope: process.env.REACT_APP_CONTARCT_NAME,
            table: 'vendorinfo',
            json: true,
        })
        return data
    }

    getTableRowsByNFT = async (accountName)=>{
        const responseData = await mainAllApi.getTableRows({
            code: process.env.REACT_APP_NFT_NAME,
            scope: nameToNumeric(accountName),
            table: 'accounts',
            json: true,
        })
        return responseData
    }

    getTableRowsByOrders = async (accountName)=>{
        const responseData = await mainAllApi.getTableRows({
            code: process.env.REACT_APP_CONTARCT_NAME,
            scope: process.env.REACT_APP_CONTARCT_NAME,
            table: 'orders',
            index_position: 2,
            key_type: "i64",
            lower_bound: nameToNumeric(accountName),
            upper_bound: nameToNumeric(accountName),
            json: true,
        })
        return responseData
    }


    getTableRowsByRecoverOrders = async (accountName)=>{
        const responseData = await mainAllApi.getTableRows({
            code: process.env.REACT_APP_CONTARCT_RECOVER,
            scope: process.env.REACT_APP_CONTARCT_RECOVER,
            table: 'orders',
            index_position: 2,
            key_type: "i64",
            lower_bound: nameToNumeric(accountName),
            upper_bound: nameToNumeric(accountName),
            json: true,
        })
        return responseData
    }


    getTableRowsByRecovery = async (accountName)=>{
        const responseData = await mainAllApi.getTableRows({
            code: process.env.REACT_APP_CONTARCT_RECOVER,
            scope: process.env.REACT_APP_CONTARCT_RECOVER,
            table: 'recorders',
            index_position: 3,
            key_type: "i64",
            lower_bound: nameToNumeric(accountName),
            upper_bound: nameToNumeric(accountName),
            json: true,
        })
        return responseData
    }

    getUserBalance = async (accountName, symbol)=>{
        const client = await getClient();
        let banlance = await client.getCurrencyBalance(
            process.env.REACT_APP_TOKEN_NAME,
            accountName,
            symbol
        )
        try {
            banlance = banlance[0].split(" ")[0] || "";
        } catch (error) {
            banlance = "0";
        }
        return banlance;
    }

    getTableRowsRecover = async (accountName)=>{
      const responseData = await mainAllApi.getTableRows({
          code: process.env.REACT_APP_CONTARCT_RECOVER,
          scope: process.env.REACT_APP_CONTARCT_RECOVER,
          table: 'recorders',
          index_position: 2,
          key_type: "i64",
          lower_bound: nameToNumeric(accountName),
          upper_bound: nameToNumeric(accountName),
          json: true,
      })
      return responseData
    }

    // transferFee = async (accountName,user_charge_amount,memo)=>{
    //     const contract = await getContract(process.env.REACT_APP_TOKEN_NAME);
    //     return contract.transfer(accountName,process.env.REACT_APP_CONTARCT_NAME,user_charge_amount,memo);
    // }

    transferFeeRecover = async (accountName,user_charge_amount,memo)=>{
      const account = process.env.REACT_APP_TOKEN_NAME
      const name = "transfer"
      const data = {
        "from": accountName,
        "to": process.env.REACT_APP_CONTARCT_RECOVER,
        "quantity": user_charge_amount,
        "memo":memo,
      }
      return await transact([{
        account,
        name,
        data,
      }]);
    }

    transferFee = async (accountName: any, user_charge_amount: any, memo: any) => {
      const account = process.env.REACT_APP_TOKEN_NAME
      const name = "transfer"
      const data = {
        "from": accountName,
        "to": process.env.REACT_APP_CONTARCT_NAME,
        "quantity": user_charge_amount,
        "memo":memo,
      }
      return await transact([{
        account,
        name,
        data,
      }]);
    }

}

export default new Server();
